module.exports = __webpack_public_path__ + "videos/about-768@1x.7b10332.webm";